export type OpenPullRequestLoadMode =
  | { kind: 'blocked' }
  | { kind: 'demo' }
  | { kind: 'live'; orgId: string; projectId: string };

export function getOpenPullRequestLoadMode({
  orgId,
  selectedProjectId,
  isDemoOrg,
}: {
  orgId: string | null | undefined;
  selectedProjectId: string | null | undefined;
  isDemoOrg: boolean;
}): OpenPullRequestLoadMode {
  if (!orgId || !selectedProjectId) return { kind: 'blocked' };
  if (isDemoOrg) return { kind: 'demo' };
  return { kind: 'live', orgId, projectId: selectedProjectId };
}
